import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAdsPlanner = Loadable({
  loader: function loader() {
    return import('../AdsPlanner.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAdsPlanner;